module.exports = __webpack_public_path__ + "static/media/cards1.a46b7852.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/cards1.png
// module id = 1211
// module chunks = 0